import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { FiBookOpen, FiClock, FiPlus } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import BabList from "../../../components/BabList";
import Button from "../../../components/Button";
import Card from "../../../components/Card";
import Loader from "../../../components/Loader";
import { setInterface } from "../../../redux/slices/interfaceSlice";
import service from "../../../service";
import BigLoader from "../../../components/BigLoader";
import swal from "@sweetalert/with-react";

export default function Bab() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loadingContent, setLoadingContent] = useState(true);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const [data, setData] = useState({});
  const [hoverId, setHoverId] = useState(null);

  const getData = () => {
    return new Promise((resolve, reject) => {
      service
        .get("/api/content/" + id + "/detail")
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          if (e.response?.status === 404) {
            history.replace("/content");
          }
          reject(e);
        });
    });
  };

  const onDelete = (id) => {
    swal({
      title: "Anda yakin?",
      text: "Anda akan menghapus ring ini",
      icon: "warning",
      buttons: ["Batal", true],
      dangerMode: true,
      cancelButton: "Batal",
    }).then((value) => {
      if (value) {
        setLoadingDelete(true);
        service.delete(`/api/bab/${id}`).then(() => {
          getData()
            .then((response) => {
              setData(response);
              setLoadingDelete(false);
              swal("Berhasil", "Ring telah dihapus", "success");
            })
            .catch((e) => {
              setLoadingDelete(false);
            });
        });
      }
    });
  };

  const reorderBab = (direction, index) => {
    const babs = data?.babs || [];
    const swapWith = direction === "up" ? index - 1 : index + 1;
    if (swapWith < 0 || swapWith >= babs.length) return;

    const ordered = [...babs];
    ordered[swapWith] = ordered.splice(index, 1, ordered[swapWith])[0];
    const withPositions = ordered.map((bab, idx) => ({
      ...bab,
      position: idx + 1,
    }));

    setSavingOrder(true);
    Promise.all(
      withPositions.map((bab, idx) =>
        service.put(`/api/bab/${bab.id}`, { position: idx + 1 })
      )
    )
      .then(() => {
        setData((prev) => (prev ? { ...prev, babs: withPositions } : prev));
      })
      .finally(() => setSavingOrder(false));
  };

  useEffect(() => {
    dispatch(
      setInterface({
        active: "Ring",
        pageTitle: data?.title ? `Kelola Ring · ${data.title}` : "Kelola Ring",
        rightButton: null,
      })
    );
  }, [dispatch, data?.title]);

  useEffect(() => {
    getData()
      .then((response) => {
        setLoadingContent(false);
        setData(response);
      })
      .catch((e) => {
        setLoadingContent(false);
      });
  }, [id]);

  if (loadingContent) {
    return (
      <div className="h-64 flex justify-center items-center flex-col">
        <Helmet>
          <title>Kelola Ring</title>
        </Helmet>
        <Loader className="bg-black-100" />
        <span className="mt-3 text-black-300 text-sm">Memuat</span>
      </div>
    );
  }

  return (
    <Fragment>
      <Card>
        <div className="flex flex-col items-center">
          <img
            src={process.env.REACT_APP_BASE_URL + data.cover}
            className="w-32 h-32 object-cover"
            alt="Cover"
          />
          <div className="flex-1 mt-5">
            <h1 className="font-bold text-base lg:text-lg text-center">
              {data.title}
            </h1>
            <div className="flex flex-wrap mt-1 justify-center">
              <span className="flex items-center text-sm mr-5">
                <FiClock className="mr-2" />{" "}
                {moment(data.created_at).format("DD/MM/YYYY")}
              </span>
              <span className="flex items-center text-sm mr-5">
                <FiBookOpen className="mr-2" /> {data.babs?.length} Ring
              </span>
            </div>
          </div>
        </div>
      </Card>
      <Card className="mt-5">
        <div className="flex items-center mb-8">
          <h3 className="text-lg lg:text-xl font-bold monda flex-1">
            Daftar Ring
          </h3>
          <Button link to={`/content/${id}/bab/add`} color="green" noFixedHeight>
            <FiPlus className="mr-1" /> Tambah Ring
          </Button>
        </div>
        {data.babs?.length > 0 ? (
          <div className="border border-white-300 rounded-sm p-2 flex flex-col gap-0 ml-2">
            {data.babs.map((item, index) => (
              <BabList
                key={item.id}
                bab={item}
                onDelete={onDelete}
                onMoveUp={() => reorderBab("up", index)}
                onMoveDown={() => reorderBab("down", index)}
                isFirst={index === 0}
                isLast={index === data.babs.length - 1}
                hovered={hoverId === item.id}
                onHover={setHoverId}
                onLeave={() => setHoverId(null)}
              />
            ))}
          </div>
        ) : (
          <div className="text-center flex flex-col justify-center items-center h-40 text-black-300">
            <p>Belum ada ring pada buku ini</p>
          </div>
        )}
      </Card>
      {(loadingDelete || savingOrder) && <BigLoader />}
    </Fragment>
  );
}
